module.exports = __webpack_public_path__ + "static/media/map-4.1fefe668.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-4.png
// module id = 586
// module chunks = 23